<template>
  <CModal :show.sync="showModal" color="warning">
    <template #header>
      <CRow style="width: 100%; height: 5px;">
        <CCol md="9">Liberar Visita Rechazada</CCol>
        <CCol md="3"></CCol>
      </CRow>
      <CButtonClose @click="showModal = false" />
    </template>

    <CRow>
      <CCol md="12">
        <p style="margin: 0;">
          ¿Seguro que deseas liberar esta visita rechazada?
          <br />
          Esta acción pondrá la visita como <b>DISPONIBLE</b>, quitará el promotor asignado,
          eliminará imágenes cargadas y limpiará checkin/checkout.
        </p>
      </CCol>
    </CRow>

    <template #footer>
      <CButton @click="closeModal" color="secondary">Cancelar</CButton>
      <CButton @click="confirmRelease" color="warning">Sí, liberar visita</CButton>
    </template>
  </CModal>
</template>

<script>
import store from '../../store';
import ws from '../../services/freelancers';

export default {
  name: 'ReleaseRejectedVisitModal',
  data () {
    return {
      showModal: false,
      visit: null
    }
  },
  methods: {
    showVisitModal (visit) {
      this.visit = visit;
      this.showModal = true;
    },
    async confirmRelease () {
      if(!this.visit || !this.visit.id){
        this.showToast('error', 'No se encontró la visita a liberar.');
        return;
      }

      this.loading();

      let response = await ws.releaseRejectedVisit(this.visit.id);

      this.closeModal();

      if(response.type == 'success'){
        this.showToast('success', 'La visita fue liberada correctamente.');
        this.$emit('refresh');
      }
      else{
        this.showToast('error', response.message);
      }

      this.loaded();
    },
    closeModal () {
      this.showModal = false;
      this.visit = null;
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
